import cHeader from '#themes/default/default/components/header/header.js';
import cOfferProduct from '#themes/default/default/components/offerProduct/offerProduct.js';

import template from './offerModal.html' with { type: 'html' };

export default {
	name: 'COfferModal',
	components: {
		cHeader,
		cOfferProduct
	},
	props: {
		app: {
			type: Object,
			default: () => null
		},
		order: {
			type: Object,
			default: () => null
		},
		page: {
			type: Object,
			default: () => null
		},
		selectedPayment: {
			type: Object,
			default: () => {}
		},
		theme: {
			type: Object,
			default: () => null
		},
		url: {
			type: Object,
			default: () => null
		},
		utils: {
			type: Object,
			default: () => null
		}
	},
	computed: {
		product() {
			const impressions = this.order.impressions;
			return impressions && impressions.length ? impressions[0] : {};
		},
		headline() {
			// Use headline from pricing portal if exists else use a general one
			return this.product && this.product.headline ? this.product.headline : this.t('offer_headline');
		}
	},
	mounted() {
		this.tracking.crossPopImpression({
			app: this.app,
			order: this.order,
			page: this.page,
			theme: this.theme,
			url: this.url,
			selectedPayment: this.selectedPayment
		});
	},
	methods: {
		async addProduct(product) {
			await this.$store.dispatch('addProduct', {
				product: product.id,
				quantity: 1,
				hideLoader: false
			});
			this.tracking.addToCart({
				order: this.order,
				url: this.url
			}, product);
		},
		async changeVariation(oldProduct, newProduct) {
			this.$emit('removeProduct', {
				productId: oldProduct
			});
			await this.$store.dispatch('changeVariation', {
				oldProduct,
				newProduct
			});
			this.$emit('addProduct', {
				productId: newProduct
			});
		},
		async acceptOffer() {
			const offerType = this.product.offerType;
			// Track offer modal cta
			this.tracking.crossPopClick({
				order: this.order,
				url: this.url
			}, this.product);
			// Add new product to the cart if offer is cross-sell
			if (offerType === 'crossSell') {
				await this.addProduct(this.product);
			}
			// Replace current product in cart if offer is upsell
			if (offerType === 'upsell') {
				const oldProduct = this.order.products[0];
				await this.changeVariation(oldProduct.id, this.product.id);
			}
			// Add offer product campaign to the URL
			await this.$nextTick();
			await this.updateUrlQuery();
		}
	},
	template
};
